import { z } from 'zod';

const insuranceObject = z.object({
    desired: z.boolean().optional(),
    existing: z.boolean().optional(),
    important: z.boolean().optional(),
});

export const schemaApplicantRSV = z.object({
    death: insuranceObject.optional(),
    unemployment: insuranceObject.optional(),
    workIncapacity: insuranceObject.optional(),
});

export type SchemaApplicantRSV = z.infer<typeof schemaApplicantRSV>;
